import { BlockSchema } from './Block.types';

import { NaiveBookMeetingBlockConfigSchema } from './blockConfig/Types';

import { z } from 'zod';

export const NaiveBookMeetingBlockSchema = BlockSchema.extend({
  blockConfig: NaiveBookMeetingBlockConfigSchema,
});
export type NaiveBookMeetingBlock = z.infer<typeof NaiveBookMeetingBlockSchema>;
